import React from 'react'
import Swal from 'sweetalert2'
function btnsweetalert() {
    const Swal = require('sweetalert2');
  return (
  Swal.fire(
  'Thank you from Phakaphol!',
  'การเข้าชมของคุณทำให้ผมรู้สึกดีใจมากๆคับ',
  'success'
)
  )
}

export default btnsweetalert